
import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class CommonLoading extends Vue {
  @Prop() private status!: number;
  @Prop() private type!: string;
  @Prop() private btnStr!: string;
  reload() {
    // 重新加载接口
    this.$emit('reload');
  }
  jump() {
    // 跳转到新的页面
    this.$emit('jump');
  }
}
